export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const REMOVE_ALL_FROM_CART = 'REMOVE_ALL_FROM_CART';
export const CONFIRM_CART = 'CONFIRM_CART';
export const SELECT_RELAY = 'SELECT_RELAY';
export const EMPTY_CART = 'EMPTY_CART';
export const ORDER_SUCCEEDED = 'ORDER_SUCCEEDED';
export const UPDATE_HEADER_HEIGHT = "UPDATE_HEADER_HEIGHT"
